module.exports = "/_next/static/images/Hero@2x-9b0537cd986b20285207e3dfc4e19733.png";